import React, { useState, useEffect } from 'react';
import InternshipCard from './InternshipCard';
import InternshipDetailsModal from './InternshipDetailsModal';
import internshipData from './internshipData';
import './Internships.css';

function Internships() {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedInternship, setSelectedInternship] = useState(null);

  useEffect(() => {
    const timeout = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="internships-page">
      <h1 className="internships-heading">My Internships</h1>

      {isLoading ? (
        <div className="loader"></div>
      ) : (
        <div className="internships-grid">
          {internshipData.map((internship) => (
            <InternshipCard
              key={internship.id}
              internship={internship}
              onSelectDetails={(item) => setSelectedInternship(item)}
            />
          ))}
        </div>
      )}

      {selectedInternship && (
        <InternshipDetailsModal
          internship={selectedInternship}
          onClose={() => setSelectedInternship(null)}
        />
      )}
    </div>
  );
}

export default Internships;
